<!-- Global Hero Section -->
<header class="hero-section-global">
  <div class="hero-background-global"
    style="background-image: url('https://images.ctfassets.net/f6ou4743hwzs/2xaL3IYyS5iU8bcXoWAOdX/9d1784950839614bbbcaa593c23ee090/whyblm.jpg'); background-position: center 30%;">
  </div>
  <div class="hero-overlay-global"></div>
  <div class="hero-content-global">
    <h1 class="hero-title-global">Museum Memberships</h1>
    <p class="lead"
      style="color: rgba(255,255,255,0.9); border: none; background: none; text-shadow: 0 2px 4px rgba(0,0,0,0.5);">
      Support historic preservation and education in Lacombe while enjoying exclusive member perks all year.
    </p>
  </div>
</header>

<main class="container memberships-container">
  <!-- Universal Perks Banner -->
  <div class="perks-banner">
    <span class="badge">Included With Every Membership</span>
    <h2>All Members Enjoy</h2>
    <div class="perks-grid">
      <div class="perk-item">
        <mat-icon class="perk-icon">check_circle</mat-icon>
        <span>1 Year Free Museum Admission</span>
      </div>
      <div class="perk-item">
        <mat-icon class="perk-icon">check_circle</mat-icon>
        <span>Access to Special Events & Lectures</span>
      </div>
      <div class="perk-item">
        <mat-icon class="perk-icon">check_circle</mat-icon>
        <span>Official Museum Coffee Mug</span>
      </div>
      <div class="perk-item">
        <mat-icon class="perk-icon">check_circle</mat-icon>
        <span>20% Discount at Museum Store</span>
      </div>
    </div>
  </div>

  <!-- Membership Tiers Grid -->
  <div class="tiers-grid">
    <!-- Student / Veteran / Senior -->
    <div class="tier-card">
      <div class="tier-header">
        <span class="tier-subtitle">Special Discount</span>
        <h3>Student / Veteran / Senior</h3>
        <div class="tier-price">
          <span class="currency">$</span>
          <span class="amount">20</span>
          <span class="period">/ year</span>
        </div>
      </div>
      <p class="tier-desc">Discounted annual membership for one individual with full member benefits.</p>
      <ul class="tier-features">
        <li><mat-icon>done</mat-icon> 1 membership card</li>
        <li><mat-icon>done</mat-icon> Free admission for 1 adult</li>
        <li><mat-icon>done</mat-icon> All universal perks included</li>
      </ul>
      <button mat-stroked-button color="primary" class="tier-btn" routerLink="/memberships/become-a-member" [queryParams]="{ tier: 'student-vet-senior' }">
        Select Plan
      </button>
    </div>

    <!-- Individual -->
    <div class="tier-card">
      <div class="tier-header">
        <span class="tier-subtitle">Standard</span>
        <h3>Individual</h3>
        <div class="tier-price">
          <span class="currency">$</span>
          <span class="amount">30</span>
          <span class="period">/ year</span>
        </div>
      </div>
      <p class="tier-desc">Full annual access for an individual history and cultural heritage enthusiast.</p>
      <ul class="tier-features">
        <li><mat-icon>done</mat-icon> 1 membership card</li>
        <li><mat-icon>done</mat-icon> Free admission for 1 adult</li>
        <li><mat-icon>done</mat-icon> Invitations to member-only tours</li>
        <li><mat-icon>done</mat-icon> All universal perks included</li>
      </ul>
      <button mat-stroked-button color="primary" class="tier-btn" routerLink="/memberships/become-a-member" [queryParams]="{ tier: 'individual' }">
        Select Plan
      </button>
    </div>

    <!-- Family (Featured) -->
    <div class="tier-card featured-tier">
      <div class="featured-badge">Most Popular</div>
      <div class="tier-header">
        <span class="tier-subtitle">Household</span>
        <h3>Family</h3>
        <div class="tier-price">
          <span class="currency">$</span>
          <span class="amount">50</span>
          <span class="period">/ year</span>
        </div>
      </div>
      <p class="tier-desc">Free admission for 2 adults in the same household and all children under 18.</p>
      <ul class="tier-features">
        <li><mat-icon>done</mat-icon> 2 membership cards</li>
        <li><mat-icon>done</mat-icon> Free admission for entire family</li>
        <li><mat-icon>done</mat-icon> Priority registration for family days</li>
        <li><mat-icon>done</mat-icon> All universal perks included</li>
      </ul>
      <button mat-flat-button color="primary" class="tier-btn featured-btn" routerLink="/memberships/become-a-member" [queryParams]="{ tier: 'family' }">
        Join as Family
      </button>
    </div>

    <!-- Patron -->
    <div class="tier-card">
      <div class="tier-header">
        <span class="tier-subtitle">Supporter</span>
        <h3>Patron</h3>
        <div class="tier-price">
          <span class="currency">$</span>
          <span class="amount">500</span>
          <span class="period">/ year</span>
        </div>
      </div>
      <p class="tier-desc">Substantial patronage supporting ongoing museum conservation and youth programs.</p>
      <ul class="tier-features">
        <li><mat-icon>done</mat-icon> All Family benefits</li>
        <li><mat-icon>done</mat-icon> 2 museum T-shirts (any size)</li>
        <li><mat-icon>done</mat-icon> Museum note cards with envelopes</li>
        <li><mat-icon>done</mat-icon> Donor recognition in annual review</li>
      </ul>
      <button mat-stroked-button color="primary" class="tier-btn" routerLink="/memberships/become-a-member" [queryParams]="{ tier: 'patron' }">
        Become a Patron
      </button>
    </div>

    <!-- Benefactor -->
    <div class="tier-card patron-tier">
      <div class="tier-header">
        <span class="tier-subtitle">Leadership Circle</span>
        <h3>Benefactor</h3>
        <div class="tier-price">
          <span class="currency">$</span>
          <span class="amount">2,000</span>
          <span class="period">/ year</span>
        </div>
      </div>
      <p class="tier-desc">Distinguished philanthropic support preserving Lacombe’s legacy for generations.</p>
      <ul class="tier-features">
        <li><mat-icon>done</mat-icon> All Patron benefits</li>
        <li><mat-icon>done</mat-icon> 2 tickets to the Annual Dinner (Catered by Sal and Judy’s)</li>
        <li><mat-icon>done</mat-icon> Permanent recognition on Benefactor Wall plaque</li>
        <li><mat-icon>done</mat-icon> Private docent-led tour for up to 10 guests</li>
      </ul>
      <button mat-flat-button color="accent" class="tier-btn benefactor-btn" routerLink="/memberships/become-a-member" [queryParams]="{ tier: 'benefactor' }">
        Become a Benefactor
      </button>
    </div>
  </div>
</main>

